import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, useId } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getCategorySelectorItemStyles } from './styles/category-selector-style';
import { convertToMultiLine, minRoundCoverage } from './utils';

export const ListItem = ({ name, size, onChangeScope }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getCategorySelectorItemStyles);
  const names = convertToMultiLine(name);
  const onClick = useCallback((e) => {
    e.stopPropagation();
    onChangeScope(name);
  }, [name, onChangeScope]);
  const isParent = name.endsWith('/');
  const linkId = useId('link');

  return (
    <div className={classes.root}>
      <div className={classes.name}>
        {names.map((n, i) => {
          const key = `category-name-${n}`;
          return i === names.length - 1 ? (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <div key={key}>{ isParent ? <Link className={classes.link} onClick={onClick} id={linkId}>{n}</Link> : (<span>{n}</span>)}</div>
          ) : (<span key={key}>{n}</span>);
        })}
      </div>
      <div className={classes.coverage}>
        {size > 0 && size < minRoundCoverage ? i18n.getString(_TL_('<0.01%')) : i18n.formatPercentToFixed(size, { digits: 2 })}
      </div>
    </div>
  );
};

ListItem.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  onChangeScope: PropTypes.func.isRequired,
};
